import {contrastColor} from '@pinecast/common/color';
import {useCSS} from '@pinecast/styles';

import {MOBILE} from './mobile';
import {useTheme} from './ThemeProvider';

type Props = {
  children: React.ReactNode;
  label: string;
  onClick: () => void;
};

const PlayerIconButton = ({children, label, onClick}: Props) => {
  const css = useCSS();
  const theme = useTheme();

  return (
    <button
      aria-label={label}
      className={css({
        alignItems: 'center',
        background: theme.primaryColor,
        appearance: 'none',
        border: 0,
        borderRadius: '6px',
        color: contrastColor(theme.primaryColor, '#eee', '#444'),
        cursor: 'pointer',
        display: 'flex',
        justifyContent: 'center',
        padding: '0 2px',
        height: '24px',
        lineHeight: '24px',
        transition: 'height 0.2s, line-height 0.2s, padding 0.2s',
        [MOBILE]: {
          height: '20px',
          lineHeight: '20px',
        },
      })}
      type="button"
      onClick={() => {
        onClick();
      }}
    >
      {children}
    </button>
  );
};

export default PlayerIconButton;
